import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loadEpisodeDemographics } from '../../../store/episodeDemographics';

import { AgeChart } from './AgeChart';
import { GenderChart } from './GenderChart';
import { CountryList } from './CountryList';

import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectEpisodeDemographics,
  selectEpisodeDemographicsStatus,
  selectDateRange,
} from '../../../store/selectors';
import { EpisodeAudienceDemographics, DateRangeWithLabel, ReduxState } from '../../../types';

type Props = {
  episodeId: string;
  status?: 'LOADING' | 'ERROR';
  episodeDemographics?: EpisodeAudienceDemographics;
  dateRange?: DateRangeWithLabel;
  loadEpisodeDemographics: typeof loadEpisodeDemographics;
};

export class EpisodeDemographics extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadEpisodeDemographics(this.props.episodeId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) return;

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadEpisodeDemographics(this.props.episodeId);
    }
  }

  render() {
    if (this.props.status === ERROR) {
      return <span data-qa="episode-demographics-error" />;
    }

    if (!this.props.episodeDemographics && this.props.status !== LOADING) {
      return null;
    }

    const { percentageByGender = [], genderDemographicsByAgeGroup = [], countryDemographics = [] } =
      this.props.episodeDemographics || {};

    return (
      <div className={styles.container}>
        <GenderChart genderData={percentageByGender} loading={this.props.status === LOADING} />
        <AgeChart ageData={genderDemographicsByAgeGroup} loading={this.props.status === LOADING} />
        {countryDemographics.length > 0 && <CountryList countryData={countryDemographics} />}
      </div>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    episodeDemographics: selectEpisodeDemographics(state),
    status: selectEpisodeDemographicsStatus(state),
    dateRange: selectDateRange(state),
  };
}

const actions = { loadEpisodeDemographics };

export const ConnectedEpisodeDemographics = connect(mapStateToProps, actions)(EpisodeDemographics);
